<dashboard-header title="My Results" titleCssIcon="results-icon" [showStatus]="true" [showPendingTasks]="false">
</dashboard-header>
<div class="container-fluid dashboard-results">
    <div class="row py-3">
        <ng-container *ngIf="results && results.length>0">
            <div class="col-12 result" *ngFor="let result of results; let i=index">
                <ng-container *ngIf="result.name == 'Principles of Equitable Behavior'">
                    <peb-results [course]="result"></peb-results>
                </ng-container>
                <ng-container *ngIf="result.name == 'Sphere Of Influence'">
                    <soi-results [course]="result"></soi-results>
                </ng-container>
            </div>
        </ng-container>
        <ng-container *ngIf="!results || results.length==0">
            <div class="col-12">
                <div class="no-results py-5 d-flex flex-column align-items-center justify-content-center"
                    *ngIf="!results || results.length == 0">
                    <svg class="py-4" width="222" height="211" viewBox="0 0 222 211" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M158.571 143.357V147.533H154.398" stroke="#00B05E" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M145.635 147.533H9.87598" stroke="#00B05E" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M5.56405 147.533H1.39111V143.357" stroke="#00B05E" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M1.39111 135.285V9.60352" stroke="#00B05E" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M1.39111 5.56706V1.3916H5.56405" stroke="#00B05E" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M14.3271 1.3916H150.087" stroke="#00B05E" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M154.398 1.3916H158.571V5.56706" stroke="#00B05E" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M158.572 13.6396V139.321" stroke="#00B05E" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M179.297 163.957V168.133H175.124" stroke="#FF92B6" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M166.361 168.132H30.6016" stroke="#FF92B6" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M26.2896 168.133H22.1167V163.957" stroke="#FF92B6" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M22.1167 155.884V30.3418" stroke="#FF92B6" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M22.1167 26.3053V22.1299H26.2896" stroke="#FF92B6" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M35.0527 22.1299H170.673" stroke="#FF92B6" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M175.124 22.1299H179.297V26.3053" stroke="#FF92B6" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M179.297 34.3779V159.92" stroke="#FF92B6" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M199.883 184.694V188.87H195.71" stroke="#FF341C" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M186.947 188.87H51.3271" stroke="#FF341C" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M46.8761 188.87H42.7031V184.694" stroke="#FF341C" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M42.7031 176.622V50.9404" stroke="#FF341C" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M42.7031 46.904V42.7285H46.8761" stroke="#FF341C" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M55.6392 42.7285H191.399" stroke="#FF341C" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M195.71 42.7285H199.883V46.904" stroke="#FF341C" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M199.884 54.9766V180.658" stroke="#FF341C" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M220.609 205.433V209.608H216.436" stroke="#008CF9" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M207.673 209.608H71.9136" stroke="#008CF9" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M67.6016 209.608H63.4287V205.433" stroke="#008CF9" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M63.4287 197.221V71.6787" stroke="#008CF9" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                        <path d="M63.4287 67.6423V63.4668H67.6016" stroke="#008CF9" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M76.3647 63.4668H211.985" stroke="#008CF9" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="6.29 6.29" />
                        <path d="M216.436 63.4668H220.609V67.6423" stroke="#008CF9" stroke-width="2"
                            stroke-miterlimit="10" />
                        <path d="M220.609 75.7148V201.396" stroke="#008CF9" stroke-width="2" stroke-miterlimit="10"
                            stroke-dasharray="5.82 5.82" />
                    </svg>
                    <div class="text-xlarge py-4 text-center">Complete at least 1 Activity to see your results</div>
                </div>
            </div>
        </ng-container>

    </div>
</div>